import { memo, useEffect } from "react";
import MultiSelectFilter from "./MultiSelectFilter";
import { useDispatch, useSelector } from "react-redux";
import { setTableFilter, setFieldFilter } from "../../store/reducers/CommonReducer";
import _ from "lodash";
import { Input } from "antd";
import { SIMPLE_ENUM, STRING } from "../../utils/Constants";
import { filterAttrByType, getTranslated } from "../../utils/CommonUtils";
import { getFormattedEnum } from "../../utils/SchemaParseUtils";
import { setPageFromIndex } from "../../store/reducers/CommonReducer"


const TableColumnFilter = (props) => {

  useEffect(() => {
    // Cleanup function that resets tempFilter
    return () => {
      dispatch(setTableFilter([]))
    };
  }, []);

  const dispatch = useDispatch()
  const tableFilter = useSelector(state => state.common.tableFilter)
  const dict = useSelector(state => state.common.dict)

  const filterTableData = async (tempFilter) => {
    let tempTableData = []

    await props.tableData.map((data) => {
      let isExistCount = 0
      tempFilter.map((filter) => {
        if (filterAttrByType(data.attribute[filter.id], filter.value, filter.type))
          isExistCount++
      })

      if (isExistCount === tempFilter.length) tempTableData.push(data)
    })

    return tempTableData
  }

  const debouncedSearch = _.debounce((value) => {
    if (value.length >= 3 || value === "") {
      handleSearch(value);
    }
  }, 300)

  const handleSearch = async (value) => {
    // Create deep copies to avoid mutating the original Redux or prop data
    let tempFilter = _.cloneDeep(tableFilter)
    let tempTableData = _.cloneDeep(props.filteredData)
    // Normalize search/filter value for consistent comparison (case-insensitive)
    value = Array.isArray(value) ? value.map(v => String(v || "").toLowerCase()) : String(value || "").toLowerCase()

    const index = tempFilter.findIndex(filter => filter.id === props.colId) // Find if a filter for the current column already exists

    if (index !== -1) {
      // --- Existing filter found ---
      if (!value || (Array.isArray(value) && value.length === 0) || // Case: user cleared the filter
        (tempFilter[index].value !== value) // Case: filter value changed
      ) {
        if (!value || (Array.isArray(value) && value.length === 0)) {
          // remove filter if cleared
          tempFilter.splice(index, 1)

          // If no filters left, reset table data; otherwise reapply remaining filters
          if (tempFilter.length === 0)
            tempTableData = props.tableData
          else
            tempTableData = await filterTableData(tempFilter)

        } else {
          // Update existing filter with new value and reapply filters
          tempFilter[index].value = value
          tempTableData = await filterTableData(tempFilter)
        }
      } else {
        // If same filter value applied again, reuse existing filtered data
        tempFilter[index].value = value
        tempTableData = tempTableData.filter(data => filterAttrByType(data.attribute[props.colId], value, props.filterType))
      }
    } else {
      // --- No existing filter for this column ---
      if (value && (!Array.isArray(value) || value.length > 0)) {
        // Add a new filter entry if valid
        tempFilter.push({
          id: props.colId,
          value: value,
          type: props.filterType
        })
        // Apply the new filter locally
        tempTableData = tempTableData.filter(data => filterAttrByType(data.attribute[props.colId], value, props.filterType))
      }
    }
    // --- Apply final filter results ---
    if (props.isDynamicAction) {
      // Call API for server-side filtration 
      const fieldFilter = tempFilter
        .filter(filter => filter.id && filter.value)
        .map(filter => `${filter.id}=${filter.value}`)
        .join(",");

      dispatch(setFieldFilter(fieldFilter))
      dispatch(setPageFromIndex(0))
      dispatch(props.fetchData())
    } else {
      // Client-side filtering
      dispatch(props.updateTableAction(tempTableData))
      dispatch(setTableFilter(tempFilter))
    }

  }

  const getFilterField = () => {

    switch (props.filterType) {
      case STRING:
        return <Input
          className="tbl-col-search"
          placeholder={getTranslated(dict, "LABEL_SEARCH")}
          // allowClear
          onChange={(e) => {
            e.stopPropagation()
            debouncedSearch(e.target.value)
          }}
          onClick={(e) => {
            e.stopPropagation()
          }}
          onPressEnter={(e) => {
            e.stopPropagation()
          }}
        />

      case SIMPLE_ENUM:
        const tempEnum = getFormattedEnum(props.enum)

        return <MultiSelectFilter
          className="tbl-col-search"
          enum={tempEnum}
          placeholder={"All"}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          handleSelect={(value) => handleSearch(value)}
        />

      default:
        return <></>
    }
  }

  return getFilterField()
}

export default memo(TableColumnFilter)